/**
 * EP P2P trading hall access — A3+ only (see + buy + sell).
 */
import { isLevelGte } from './levels.js';

/** Minimum membership level to view / trade in the EP hall. */
export const EP_TRADE_MIN_LEVEL = 'A3';

export function qualifiesForEpTrade(levelCode: string): boolean {
  return isLevelGte(levelCode, EP_TRADE_MIN_LEVEL);
}

/** Prefer 服务级 (reward_level); fall back to users.level_code. */
export function qualifiesForEpTradeProfile(input: {
  level_code?: string | null;
  reward_level_code?: string | null;
}): boolean {
  const reward = input.reward_level_code?.trim();
  if (reward) return qualifiesForEpTrade(reward);
  const userLevel = input.level_code?.trim();
  return userLevel ? qualifiesForEpTrade(userLevel) : false;
}
